type PublicDashboardStatus = {
  snapshot?: unknown | null;
  worker?: { online?: boolean } | null;
};

export function publicResearchDataStatus(dashboard: PublicDashboardStatus | null | undefined): string {
  if (dashboard?.worker?.online) return '研究数据链路在线';
  if (dashboard?.snapshot) return '研究数据已同步';
  return '研究数据暂不可用';
}
